import validator from 'validator';
import Moment from 'moment';

export const validateZipcode = x => validator.isPostalCode(x, 'US');

export const validateEmail = x => validator.isEmail(x);

export const validateTaxIdNum = x => /^\d+$/.test(x)
  && x.substring(0, 3) !== '000' && x.substring(3, 5) !== '00' && x.substring(5, 9) !== '0000';

export const validateTaxIdNumLen = x => x.length === 9;

export const validatePhone = x => validator.isMobilePhone(x, 'en-US');

export const validateDate = x => Moment(x, 'MM/DD/YYYY').isValid() && Moment().diff(Moment(x, 'MM/DD/YYYY'), 'years') < 118;

export const validateDOBisOverEighteen = x => Moment().diff(Moment(x, 'MM/DD/YYYY'), 'years') >= 18;

export const validatePassword = x => x.length >= 8;

export const validatePasswordChars = x => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&?*])/.test(x);

export const validateName = x => (/^[a-zA-Z\s-.]+$/mg.test(x));

export const validateNamePlain = x => (/^[a-zA-Z]+$/mg.test(x));

export const validateTickerChars = x => (/^[a-zA-Z0-9\s.,]+$/mg.test(x));

// eslint-disable-next-line no-useless-escape
export const validateAddress = x => (/^[a-zA-Z0-9\s~`!@#$%^&*()_+\-=\[\{\]\}|:',.\/? ]+$/mg.test(x));



// WEBPACK FOOTER //
// ./src/components/Forms/Validators/index.js